import React from 'react'
import TransferEndBanner from './TransferEndBanner'
import VoucherEndBanner from './VoucherEndBanner'
import { useStore } from 'effector-react'
import { orderStore } from '../../store/order'

const EndBanner = () => {
  const order = useStore(orderStore)
  if (order?.ended?.type === 'VOUCHER') {
    return <VoucherEndBanner />
  }
  return <TransferEndBanner />
}

export default EndBanner
